import { motion } from "framer-motion";


export default function FeatureCardSoftware({ title, color, features, icon }) {
  // console.log("FeatureCard icon:", icon);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}  // Start hidden and slightly lower
      animate={{ opacity: 1, y: 0 }}  // Fade-in and move to normal position
      transition={{ duration: 0.6, ease: "easeOut" }} // Smooth transition
      whileHover={{ scale: 1.05, boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.1)" }} // Hover effect
      className="shadow-lg rounded-2xl bg-white backdrop-blur-lg p-4 lg:p-6 md:p-6"
    >
      <div className="flex items-start gap-2 justify-start">
        <motion.img
          src={icon}
          alt=""
          className="lg:w-12 lg:h-12 size-9"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
        />
      </div>

      <h3 className={`lg:text-2xl text-[16px] font-extrabold mb-3 text-start ${color}`}>{title}</h3>

      <ul className="list-disc font-semibold px-4 space-y-2 text-gray-500 text-start poppins-font2 lg:text-base text-[14px] md:text-[18px] tracking-tight poppins-font2 leading-relaxed">
        {features.map((feature, index) => (
          <motion.li
            key={index}
            initial={{ opacity: 0, x: -10 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: index * 0.1, duration: 0.3 }}
          >
            <span className="text-gray-500 text-start poppins-font2">{feature.title}:</span> {feature.description}
          </motion.li>
        ))}
      </ul>
    </motion.div>
  );
}
